export default __webpack_public_path__ + "static/adagio-b2f7b21a4ae429a249ee0bf18b975f5a.png";